var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../../common';
export var WapHoursMismatchDialog = function (_a) {
    var open = _a.open, mismatchedLocations = _a.mismatchedLocations, onClose = _a.onClose;
    var t = useTranslation('wizard', { keyPrefix: 'workVolume.hoursMismatch' }).t;
    return (_jsx(ConfirmDialog, { open: open, onClose: onClose, title: t('title'), cancelButtonText: "close", message: _jsxs(_Fragment, { children: [_jsx(Typography, { children: t('description') }), _jsx(List, __assign({ dense: true, disablePadding: true, component: "ul", sx: { listStyleType: 'disc', pl: 3, mt: 1.5 } }, { children: mismatchedLocations.map(function (name) { return (_jsx(ListItem, __assign({ disableGutters: true, sx: { display: 'list-item', py: 0 } }, { children: _jsx(ListItemText, { primary: _jsx(Typography, __assign({ fontWeight: 700, color: "text.primary" }, { children: name })) }) }), name)); }) }))] }) }));
};
